import {
  MorphemeTilePresentationProvider,
  useMorphemeTilePresentation,
} from "@-/dev.improve.haniverse.routes.nav.app._components.morpheme.tile.ui.presentation";
import { useMemo } from "react";
import { View } from "@-/com.npmjs.react-native";
import { toneForPinyin } from "@-/dev.improve.haniverse.routes.nav.app._lib.morpheme.transcription";

function useAdditionalPinyinToneColor(pinyin: string): string | null {
  const { toneColors } = useMorphemeTilePresentation();
  return useMemo(() => {
    const tone = toneForPinyin(pinyin);
    if (tone === null) {
      return null;
    }
    return toneColors[tone];
  }, [pinyin, toneColors]);
}

function MorphemeGlyphTilePinyinDotContent({ pinyin }: { pinyin: string }) {
  const color = useAdditionalPinyinToneColor(pinyin);

  return (
    <View
      className={
        color === null ? "h-0.5 w-2 rounded-full bg-muted-foreground" : "h-0.5 w-2 rounded-full"
      }
      style={color !== null ? { backgroundColor: color } : undefined}
    />
  );
}

export function MorphemeGlyphTilePinyinDot(
  props: React.ComponentProps<typeof MorphemeGlyphTilePinyinDotContent>,
) {
  return (
    <MorphemeTilePresentationProvider>
      <MorphemeGlyphTilePinyinDotContent {...props} />
    </MorphemeTilePresentationProvider>
  );
}
